import { Deal, User } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { isBwiInventory } from 'src/services/data/accounts.service'

type DealGate = Pick<Deal, 'deal_id' | 'buyer_id' | 'supplier_id' | 'buyer_confirmed' | 'seller_confirmed'>

// Per-deal eligibility for the Clone-tab actions (see guards/wa21001-clone-actions.md).
export function canUseCloneActions(
  deal: DeepReadonly<DealGate> | undefined,
  user: DeepReadonly<Pick<User, 'role'>> | undefined,
): boolean {
  if (user?.role !== 'trader') return true
  const confirmedToAnyone = !!(deal?.buyer_confirmed || deal?.seller_confirmed)
  if (!confirmedToAnyone) return true // any Draft deal
  const id = deal?.deal_id ?? ''
  if (id.endsWith('TCI')) return false // confirmed TCI — never
  if (id.endsWith('TC')) return isBwiInventory(deal.buyer_id) || isBwiInventory(deal.supplier_id) // confirmed TC — either-party inventory
  return true // confirmed non-TC/TCI — unrestricted
}

// Selected deals the current user may NOT run a clone action on.
export function disallowedCloneActionDeals<T extends DealGate>(
  deals: readonly DeepReadonly<T>[],
  user: DeepReadonly<Pick<User, 'role'>> | undefined,
): DeepReadonly<T>[] {
  return deals.filter(deal => !canUseCloneActions(deal, user))
}
